// Le comparatif : la colonne SELFCNTRL est un bloc bleu nuit qui dépasse du
// tableau — on la voit avant de lire une seule ligne.
import { useT } from '../../lib/i18n'
import { Check, Cross } from './Icons'

function Mark ({ ok }) {
  return (
    <span className={ok ? 'lp-mk lp-mk--y' : 'lp-mk lp-mk--n'} role="img" aria-label={ok ? 'Yes' : 'No'}>
      {ok ? <Check /> : <Cross />}
    </span>
  )
}

export default function Rivals () {
  const r = useT().rivals
  return (
    <section className="lp-sec" id="compare">
      <div className="lp-wrap lp-cmp">
        <div className="lp-cmp__head lp-rv">
          <span className="lp-kicker">{r.kicker}</span>
          <h2 className="lp-h2">{r.title}</h2>
          <p className="lp-lead">{r.lead}</p>
          <p className="lp-cmp__note">{r.note}</p>
        </div>

        <div className="lp-riv lp-rv">
          <table>
            <thead>
              <tr>
                <td />
                <th scope="col">{r.colOthers}</th>
                <th scope="col" className="lp-riv__on">{r.colUs}</th>
              </tr>
            </thead>
            <tbody>
              {r.rows.map(row => (
                <tr key={row.k}>
                  <th scope="row">{row.k}</th>
                  <td><Mark ok={row.others} /></td>
                  <td className="lp-riv__on"><Mark ok={row.us} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
